module.exports = __webpack_public_path__ + "img/kubernetes.d1998999.svg";